import { api } from './client'

// Daily Check-in record API — stores the free-text brain dump tied to a
// user/date and exposes today's semantic extraction (the "HAIVEN NOTICED"
// summary surfaced after submit).
//
// Local-date contract: callers should pass the user's local YYYY-MM-DD
// (``todayKey()`` in CheckIn.jsx) on every read AND on the upsert.
// Without it, the server falls back to UTC ``date.today()``, which
// produces evening-vs-next-morning leakage west of UTC (e.g. 6pm MT
// stamps next-day UTC, then re-renders as "today" the next morning).
const withTargetDate = (path, date) =>
  date ? `${path}?target_date=${encodeURIComponent(date)}` : path;

export const dailyCheckinApi = {
  upsert: (payload, token) => api.post('/checkin', payload, token),
  today: (token, date) => api.get(withTargetDate('/checkin/today', date), token),
  extractionToday: (token, date) => api.get(withTargetDate('/checkin/extraction/today', date), token),
  // Daily felt-alignment self-report (alignment/regulation/presence 1–5).
  // Feeds Layer 3 (Foundation Alignment). Must be written BEFORE /rci/compute
  // so the snapshot's Values Alignment Index picks it up for the same day.
  // ``payload`` carries the local YYYY-MM-DD as ``date`` (same contract as
  // the brain-dump upsert) so the row buckets against the user's calendar.
  selfReport: (payload, token) => api.post('/checkin/self-report', payload, token),
  selfReportToday: (token, date) => api.get(withTargetDate('/checkin/self-report/today', date), token),
  // Read-only aggregate of a past day's check-in context. Used by the
  // historical CheckIn surface reached from Intelligence Feed CTAs.
  // ``date`` is a YYYY-MM-DD string the user's local calendar resolves to.
  history: (token, date) => api.get(`/checkin/history?date=${encodeURIComponent(date)}`, token),
}
